import "../scss/app.scss";
import { mapStyles } from './map-styles';
import { setCookie } from './helpers';
import createHTMLMapMarker from './map-marker';
import logo from './logo-svg';

jQuery(document).ready(function ($) {
  $('.lazy').Lazy();

  if (window.document.documentMode) {
    $('body').addClass('ie');
  }

  (function(){
    const offset = $('.js-hero-section').height() - $('.js-header').height();
    if(!offset) return;
    window.onscroll = () => {
      if (document.body.scrollTop > offset || document.documentElement.scrollTop > offset) {
        $('.js-header').addClass('header--schrinked')
      } else {
        $('.js-header').removeClass('header--schrinked')
      }
    };
  })();

  $('.js-project-slider').slick({
    dots: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    lazyLoad: 'ondemand',
    nextArrow: $('.js-project-arrow-next'),
    prevArrow: $('.js-project-arrow-prev'),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // $('.js-project-slider').on('beforeChange', () => {
  //   $('.js-project-slider-lazy').lazy({
  //     bind: "event",
  //     delay: 0
  //   });
  // });
  
  $('.js-other-projects-slider').slick({
    dots: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    lazyLoad: 'ondemand',
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: $('.js-others-projects-arrow-next'),
    prevArrow: $('.js-others-projects-arrow-prev'),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // $('.js-other-projects-slider').on('beforeChange', () => {
  //   $('.js-other-projects-slider-lazy').lazy({
  //     bind: "event",
  //     delay: 0
  //   });
  // });

  $('.js-clients-slider').slick({
    dots: false,
    arrows: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    nextArrow: $('.js-clients-arrow-next'),
    prevArrow: $('.js-clients-arrow-prev'),
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1230,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  // $('.js-clients-slider').on('beforeChange', () => {
  //   $('.js-clients-slider-lazy').lazy({
  //     bind: "event",
  //     delay: 0
  //   });
  // });

  $('.js-hero-slider').slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    infinite: true,
    cssEase: 'linear'
  });

  (function(){
    let element = null;
    const outsideClickListener = event => {
      if (!$(event.target).closest('.modal__dialog').length ) {
        closeModal($(element));
      }
    }

    const escKeyListener = (e) => {
      if(e.key === "Escape") closeModal($(element));
    };

    const openModal = ($el) => {
      $el.fadeIn();
      element = $el[0];
      $('body').addClass('no-scroll');
      document.addEventListener('click', outsideClickListener);
      document.addEventListener('keyup', escKeyListener);
    };

    const closeModal = ($el) => {
      $el.fadeOut();
      element = null;
      $('body').removeClass('no-scroll');
      document.removeEventListener('click', outsideClickListener);
      document.removeEventListener('keyup', escKeyListener);
    };

    $('.js-modal-btn').click(function(e){
      e.preventDefault();
      e.stopPropagation();
      openModal($(`.js-modal[data-modal="${$(this).data('modal')}"]`));
    });
  
    $('.js-modal-close-btn').click(function(e){
      e.preventDefault();
      closeModal($(this).parents('.js-modal'));
    });
  })();


  $('.js-menu-burger').click(function(e){
    e.preventDefault();
    $('.js-mobile-nav').addClass('header__nav--opened');
    $('.js-mobile-nav').css('bottom', `calc(100% - ${$('.js-mobile-nav').innerHeight() + $('.header__inner').innerHeight()}px)`);
  });
  $('.js-close-nav').click(function(e){
    e.preventDefault();
    $('.js-mobile-nav').removeClass('header__nav--opened');
    $('.js-mobile-nav').css('bottom','100%');
  });
  $('.js-contacts-btn').click(function(e){
    e.preventDefault();
    if($(this).hasClass('active')){
      $('.js-contacts-btn').removeClass('active');
      $('.js-header-contacts').removeClass('header__contacts--opened');
      $('.js-header-contacts').css('bottom', '100%');
    } else {
      $(this).addClass('active');
      $('.js-header-contacts').addClass('header__contacts--opened');
      $('.js-header-contacts').css('bottom', `calc(100% - ${$('.js-header-contacts').innerHeight() + $('.header__inner').innerHeight()}px)`);
    }
    
  });
  $('.js-close-contacts-btn').click(function(e){
    e.preventDefault();
    $('.js-contacts-btn').removeClass('active');
    $('.js-header-contacts').removeClass('header__contacts--opened');
    $('.js-header-contacts').css('bottom', '100%');
  });
  
  const validateForm = ($form) => {
    let valid = true;
    $form.find('.js-required').each(function(){
      if($(this).val()){
        return $(this).removeClass('invalid');
      }
      valid = false;
      $(this).addClass('invalid');
    });
    return valid;
  };

  $('.js-contact-form').submit(function(e){
    e.preventDefault();
    const $self = $(this);
    if(!validateForm($self)) return;
    const $btn = $self.find('[type="submit"]');
    $btn.addClass('spinner').prop('disabled', true);
    const $res = $('<div class="form__response"></div>');
    $.ajax({
      method: 'POST',
      url: $self.attr('action'),
      dataType: 'json',
      data: {
        action: 'contactform',
        name: $self.find('[name="name"]').val(),
        company: $self.find('[name="company"]').val(),
        phone: $self.find('[name="phone"]').val(),
        email: $self.find('[name="email"]').val(),
        message: $self.find('[name="message"]').val(),
        coffee: $self.find('[name="coffee"]').val()
      },
      success: (res) => {
        if(!res.success){
          $res.addClass('error');
        }
        $btn.parent().html($res.text(res.message));
      },
      errorr: (err) => {
        console.log(err);
      }
    })
  });

  $('.js-cv-form').submit(function(e){
    e.preventDefault();
    const $self = $(this);
    if(!validateForm($self)) return;
    const $btn = $self.find('[type="submit"]');
    $btn.addClass('spinner').prop('disabled', true);
    const $res = $('<div class="form__response"></div>');
    const data = new FormData($self[0]);
    data.append('action', 'cvform');
    $.ajax({
      method: 'POST',
      url: $self.attr('action'),
      enctype: 'multipart/form-data',
      dataType: 'json',
      processData: false,
      contentType: false,
      cache: false,
      data,
      success: (res) => {
        if(!res.success){
          $res.addClass('error');
        }
        $btn.parent().html($res.text(res.message));
      },
      errorr: (err) => {
        console.log(err);
      }
    })
  });

  $('.js-file-input').change(function(e){
    console.log();
    if(e.target.files.length){
      const name = e.target.files[0].name;
      $('.js-file-label').hide();
      $('.js-file-selected span span').text(name);
      $('.js-file-selected').show();
    } else {
      $('.js-file-label').show();
      $('.js-file-selected').hide();
    }
  });

  $('.js-file-remove').click(function(e){
    e.preventDefault();
    $('.js-file-input').val("").trigger('change');
  });

  $('.js-cookie-btn').click(function(e){
    e.preventDefault();
    setCookie('8748685895', 1, 365);
    $('.js-cookie-bar').remove();
  });

  // End of document ready
});

window._initMap = () => {
  const screenWidth = $(window).width();
  const mapDiv = document.querySelector(".js-map");
  const icon = screenWidth > 991 ? '/wp-content/themes/ideaformus/assets/img/map-marker.svg' : '/wp-content/themes/ideaformus/assets/img/map-marker-mobile.svg';
  if(!mapDiv) return;
  const latLng = { 
    lat: 54.687723, 
    lng: 25.266008 
  };
  const map = new google.maps.Map(mapDiv, {
    center: { lat: latLng.lat, lng: screenWidth > 991 ? latLng.lng + 0.052 * $(window).width() / 1920 : latLng.lng },
    zoom: 14,
    styles: mapStyles
  });
  
  if(screenWidth > 991){
    const marker = createHTMLMapMarker({
      map,
      latlng: new google.maps.LatLng(latLng.lat, latLng.lng),
      html: `
        <div class="contacts__map__marker">${logo}</div>
      `
    });
  } else {
    const marker = new google.maps.Marker({
      position: latLng, 
      map,
      icon
    });
  }
};